import { Component, Host, h } from '@stencil/core'
import gogreen from './assets/dhl-gogreen.svg'

/**
 * Represents the shipping information component.
 */
@Component({
    tag: 'wf-shipping',
    styleUrl: 'wf-shipping.scss',
    shadow: true,
})
// eslint-disable-next-line require-jsdoc
export class WfShipping {

    /**
     * @inheritDoc
     */
    render() {
        return (
            <Host>
                <div class="title" part="title">Versand</div>
                <div>3,99&euro; Versandkosten</div>
                <div>Versandkostenfrei ab 99&euro;</div>
                <div class="logos">
                    <img src={gogreen} alt="DHL GoGreen Logo"/>
                </div>
            </Host>
        )
    }
}
